import React from 'react';
import classNames from 'classnames';

import { ReactComponent as Link } from 'assets/icons/link.svg';

const pathName = window.location.pathname;
const hostName = window.location.hostname;
let query = new URLSearchParams(window.location.search);

function getLinkStlye()
{
	if(pathName.toLowerCase() === '/travelsafe/flyin' || pathName.toLowerCase() === '/travelsafe/flyin/' || hostName === 'www.flyin.com' || hostName === 'flyin.com' || hostName === "qa2.flyin.com")
	{
		if(query.get("lng")!="en")
		return {transform: "scaleX(-1)"}
	}
}
function Target(props) {
	const { blank, children, className, handler, iconSize, ...otherProps } = props;
	const targetClassName = classNames('td-none hover:td-underline lh-copy lh-copy--xs fs-3 c-secondary-500 fw-500', className);

	function clickHandler(){
		handler && handler(otherProps)
	}
	return (
		<a className={targetClassName} target={blank && '_blank'} {...otherProps} onClick={() => clickHandler()}>
			{children}
			{blank && <Link style={getLinkStlye()} height={iconSize} width={iconSize} className='c-secondary-500 mx-1' />}
		</a>
	);
}

Target.defaultProps = {
	iconSize: 12
}

export default Target;
